// src/constants/purchaseTypes.js
//
// Pick-list for properties.purchase_type. Ordered — the form renders
// options in this order, so changes here shift the displayed dropdown.
//
// Why centralized: scattered string literals create silent typos at scale
// (the same reason statuses.js exists). One import site, one source of
// truth.
//
// Future: this list is intended to become admin-editable via the planned
// Table Management screen (M4). When that lands, the source moves from
// this constant to a DB-backed lookup table; consumers keep importing the
// same name (PURCHASE_TYPES) so call sites don't change.

export const PURCHASE_TYPES = [
  'Traditional',
  'Portfolio',
  '1031 Exchange',
  'Foreclosure',
  'Auction',
  'New Construction',
  'Ground Lease',
];
